import { render, staticRenderFns } from "./AffiliateSalesReport.vue?vue&type=template&id=16d2e732&scoped=true"
import script from "./AffiliateSalesReport.vue?vue&type=script&lang=js"
export * from "./AffiliateSalesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d2e732",
  null
  
)

export default component.exports